import { render, staticRenderFns } from "./docentes.vue?vue&type=template&id=0a1bf2b7"
import script from "./docentes.vue?vue&type=script&lang=js"
export * from "./docentes.vue?vue&type=script&lang=js"
import style0 from "./docentes.vue?vue&type=style&index=0&id=0a1bf2b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports